import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { value: null }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = ["value", "title"]
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { value: null }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = { class: "input-group-text" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "input-group" }
const _hoisted_40 = { class: "input-group-text" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = { class: "input-group-text" }
const _hoisted_46 = { class: "col" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "input-group" }
const _hoisted_49 = { class: "input-group-text" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "mb-3" }
const _hoisted_55 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_56 = {
  key: 1,
  class: "text-success"
}
const _hoisted_57 = { class: "d-flex gap-2" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "col-7" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_63 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_64 = { class: "table-responsive" }
const _hoisted_65 = { class: "table table-sm table-hover" }
const _hoisted_66 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_67 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-5" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "mb-3" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col" }
const _hoisted_75 = { class: "mb-3" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { value: null }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "col" }
const _hoisted_80 = { class: "mb-3" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = { value: null }
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col" }
const _hoisted_86 = { class: "mb-3" }
const _hoisted_87 = ["value", "title"]
const _hoisted_88 = { class: "col" }
const _hoisted_89 = { class: "mb-3" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { value: null }
const _hoisted_92 = ["value", "title"]
const _hoisted_93 = { class: "col" }
const _hoisted_94 = { class: "mb-3" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col" }
const _hoisted_97 = { class: "mb-3" }
const _hoisted_98 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_99 = ["onClick"]
const _hoisted_100 = { class: "col" }
const _hoisted_101 = { class: "mb-3" }
const _hoisted_102 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "col" }
const _hoisted_106 = { class: "mb-3" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col" }
const _hoisted_109 = { class: "mb-3" }
const _hoisted_110 = { class: "input-group mb-2" }
const _hoisted_111 = {
  key: 0,
  class: "d-flex flex-wrap gap-1"
}
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_114 = {
  key: 1,
  class: "text-success"
}
const _hoisted_115 = ["disabled"]
const _hoisted_116 = { class: "col-7" }
const _hoisted_117 = { key: 0 }
const _hoisted_118 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_119 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_120 = { class: "table-responsive" }
const _hoisted_121 = { class: "table table-sm table-hover" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[78] || (_cache[78] = _createElementVNode("h1", null, "Add blade damage", -1)),
      _cache[79] || (_cache[79] = _createElementVNode("p", null, " This is the main interaction for adding and viewing blade damage records. Please be mindful that there is no ability to edit prior records as of current, and so all changes should be made with caution. ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[58] || (_cache[58] = _createElementVNode("h3", null, "Add physical damage or repair", -1)),
        (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.loadError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Site", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.damageForm.site_id) = $event)),
                class: "form-select",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadTurbinesForSite && _ctx.loadTurbinesForSite(...args)))
              }, [
                _cache[36] || (_cache[36] = _createElementVNode("option", { value: null }, "Select site", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: site.site_id,
                    value: site.site_id
                  }, _toDisplayString(site.name), 9, _hoisted_7))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.damageForm.site_id]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label" }, "Asset", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.damageForm.turbine_id) = $event)),
                class: "form-select",
                disabled: !_ctx.damageForm.site_id,
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadBladesForTurbine && _ctx.loadBladesForTurbine(...args)))
              }, [
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.damageForm.site_id ? "Select asset" : "Select site first"), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.turbines, (t) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: t.turbine_id,
                    value: t.turbine_id
                  }, _toDisplayString(t.name), 9, _hoisted_12))
                }), 128))
              ], 40, _hoisted_10), [
                [_vModelSelect, _ctx.damageForm.turbine_id]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Blade", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.damageForm.blade_id) = $event)),
                class: "form-select",
                disabled: !_ctx.damageForm.turbine_id
              }, [
                _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.damageForm.turbine_id ? "Select blade" : "Select asset first"), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blades, (b) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: b.blade_id,
                    value: b.blade_id
                  }, _toDisplayString(b.name) + " | S/N: " + _toDisplayString(b.serial), 9, _hoisted_17))
                }), 128))
              ], 8, _hoisted_15), [
                [_vModelSelect, _ctx.damageForm.blade_id]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label" }, "Component", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.damageForm.component_id) = $event)),
                class: "form-select",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loadDamageTypesForComponent && _ctx.loadDamageTypesForComponent(...args)))
              }, [
                _cache[40] || (_cache[40] = _createElementVNode("option", { value: null }, "Select component", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeComponents, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.blade_component_id,
                    value: c.blade_component_id,
                    title: c.description
                  }, _toDisplayString(c.component), 9, _hoisted_21))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.damageForm.component_id]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label" }, "Damage type", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.damageForm.damage_type_id) = $event)),
                class: "form-select",
                disabled: !_ctx.damageForm.component_id
              }, [
                _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.damageForm.component_id ? "Select damage type" : "Select component first"), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeDamageTypes, (d) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: d.blade_damage_type_id,
                    value: d.blade_damage_type_id
                  }, _toDisplayString(d.damage), 9, _hoisted_26))
                }), 128))
              ], 8, _hoisted_24), [
                [_vModelSelect, _ctx.damageForm.damage_type_id]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label" }, "Damage category", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.damageForm.category) = $event)),
                class: "form-select"
              }, [
                _cache[43] || (_cache[43] = _createElementVNode("option", { value: null }, "Select category", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_29)
                }), 64))
              ], 512), [
                [_vModelSelect, _ctx.damageForm.category]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label" }, "Date", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.damageForm.date) = $event)),
                type: "date",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.damageForm.date]
              ])
            ])
          ])
        ]),
        (_ctx.damageForm.blade_id && _ctx.damageForm.component_id && _ctx.damageForm.damage_type_id && _ctx.damageForm.category)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[56] || (_cache[56] = _createElementVNode("hr", null, null, -1)),
              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("p", null, " All of the below are in m, unless the % is specified instead. They do not all need filling, but all known fields should be filled ")
              ], -1)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label" }, "Span start", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.damageForm.span_start) = $event)),
                        type: "number",
                        class: "form-control",
                        placeholder: "Span start"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.damageForm.span_start,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-1",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.damageForm.span_start_pct) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.damageForm.span_start_pct]
                        ]),
                        _cache[46] || (_cache[46] = _createTextVNode(" % ", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "Span end", -1)),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.damageForm.span_end) = $event)),
                        type: "number",
                        class: "form-control",
                        placeholder: "Span end"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.damageForm.span_end,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-1",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.damageForm.span_end_pct) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.damageForm.span_end_pct]
                        ]),
                        _cache[48] || (_cache[48] = _createTextVNode(" % ", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label" }, "Chord start", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.damageForm.chord_start) = $event)),
                        type: "number",
                        class: "form-control",
                        placeholder: "Chord start"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.damageForm.chord_start,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-1",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.damageForm.chord_start_pct) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.damageForm.chord_start_pct]
                        ]),
                        _cache[50] || (_cache[50] = _createTextVNode(" % ", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[53] || (_cache[53] = _createElementVNode("label", { class: "form-label" }, "Chord end", -1)),
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.damageForm.chord_end) = $event)),
                        type: "number",
                        class: "form-control",
                        placeholder: "Chord end"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.damageForm.chord_end,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-1",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.damageForm.chord_end_pct) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.damageForm.chord_end_pct]
                        ]),
                        _cache[52] || (_cache[52] = _createTextVNode(" % ", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", { class: "form-label" }, "Depth max", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.damageForm.depth_max) = $event)),
                      type: "number",
                      class: "form-control",
                      placeholder: "Depth max"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.damageForm.depth_max,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[55] || (_cache[55] = _createElementVNode("label", { class: "form-label" }, "Depth min", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.damageForm.depth_min) = $event)),
                      type: "number",
                      class: "form-control",
                      placeholder: "Depth min"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.damageForm.depth_min,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ])
              ]),
              (_ctx.saveError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_ctx.saveError), 1))
                : _createCommentVNode("", true),
              (_ctx.saveSuccess)
                ? (_openBlock(), _createElementBlock("p", _hoisted_56, "Record saved successfully."))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.saving,
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.saveDamage(false)))
                }, _toDisplayString(_ctx.saving ? "Saving..." : "Save damage record"), 9, _hoisted_58),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.saving,
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.saveDamage(true)))
                }, _toDisplayString(_ctx.saving ? "Saving..." : "Save repair record"), 9, _hoisted_59)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_60, [
        _cache[60] || (_cache[60] = _createElementVNode("h3", null, "Damage records", -1)),
        (_ctx.bladeHealthLoading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Loading..."))
          : (!_ctx.damageForm.site_id)
            ? (_openBlock(), _createElementBlock("p", _hoisted_62, "Select a site to view damage records."))
            : (_ctx.bladeHealthRecords.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_63, "No records found for the current selection."))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.bladeHealthRecords.length) + " record" + _toDisplayString(_ctx.bladeHealthRecords.length === 1 ? "" : "s") + " found.", 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("table", _hoisted_65, [
                      _cache[59] || (_cache[59] = _createElementVNode("thead", { class: "thead thead-dark" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "id"),
                          _createElementVNode("th", null, "Date"),
                          _createElementVNode("th", null, "Blade"),
                          _createElementVNode("th", null, "Component"),
                          _createElementVNode("th", null, "Damage"),
                          _createElementVNode("th", null, "Cat"),
                          _createElementVNode("th", null, "Type")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeHealthRecords, (r) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: r.blade_health_id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(r.blade_health_id), 1),
                            _createElementVNode("td", null, _toDisplayString(r.date.slice(0, 10)), 1),
                            _createElementVNode("td", null, _toDisplayString(r.blade_serial), 1),
                            _createElementVNode("td", null, _toDisplayString(r.component), 1),
                            _createElementVNode("td", null, _toDisplayString(r.damage), 1),
                            _createElementVNode("td", null, _toDisplayString(r.category), 1),
                            _createElementVNode("td", null, [
                              (r.repair)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Repair"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_67, "Damage"))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ], 64))
      ]),
      _cache[80] || (_cache[80] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _cache[73] || (_cache[73] = _createElementVNode("h3", null, "Add structural change", -1)),
          _cache[74] || (_cache[74] = _createElementVNode("p", null, "View and manage the structural response of the turbine, and attribute them to instances of blade damage", -1)),
          _cache[75] || (_cache[75] = _createElementVNode("p", null, "If the change can be applied to the whole turbine, leave the blade selection blank", -1)),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _cache[62] || (_cache[62] = _createElementVNode("label", { class: "form-label" }, "Site", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.structuralForm.site_id) = $event)),
                  class: "form-select",
                  onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.loadStructuralTurbinesForSite && _ctx.loadStructuralTurbinesForSite(...args)))
                }, [
                  _cache[61] || (_cache[61] = _createElementVNode("option", { value: null }, "Select site", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: site.site_id,
                      value: site.site_id
                    }, _toDisplayString(site.name), 9, _hoisted_73))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.structuralForm.site_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _cache[63] || (_cache[63] = _createElementVNode("label", { class: "form-label" }, "Asset", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.structuralForm.turbine_id) = $event)),
                  class: "form-select",
                  disabled: !_ctx.structuralForm.site_id,
                  onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.loadStructuralBladesForTurbine && _ctx.loadStructuralBladesForTurbine(...args)))
                }, [
                  _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.structuralForm.site_id ? "Select asset" : "Select site first"), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structuralTurbines, (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: t.turbine_id,
                      value: t.turbine_id
                    }, _toDisplayString(t.name), 9, _hoisted_78))
                  }), 128))
                ], 40, _hoisted_76), [
                  [_vModelSelect, _ctx.structuralForm.turbine_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _cache[64] || (_cache[64] = _createElementVNode("label", { class: "form-label" }, "Blade", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.structuralForm.blade_id) = $event)),
                  class: "form-select",
                  disabled: !_ctx.structuralForm.turbine_id
                }, [
                  _createElementVNode("option", _hoisted_82, _toDisplayString(_ctx.structuralForm.turbine_id ? "Select blade" : "Select asset first"), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structuralBlades, (b) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: b.blade_id,
                      value: b.blade_id
                    }, _toDisplayString(b.name) + " | " + _toDisplayString(b.serial), 9, _hoisted_83))
                  }), 128))
                ], 8, _hoisted_81), [
                  [_vModelSelect, _ctx.structuralForm.blade_id]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _cache[66] || (_cache[66] = _createElementVNode("label", { class: "form-label" }, "Metric type", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.structuralForm.metric_type_id) = $event)),
                  class: "form-select",
                  onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.loadMetricsForType && _ctx.loadMetricsForType(...args)))
                }, [
                  _cache[65] || (_cache[65] = _createElementVNode("option", { value: null }, "Select metric type", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricTypes, (mt) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: mt.metric_type_id,
                      value: mt.metric_type_id,
                      title: mt.description
                    }, _toDisplayString(mt.name), 9, _hoisted_87))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.structuralForm.metric_type_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _cache[67] || (_cache[67] = _createElementVNode("label", { class: "form-label" }, "Metric", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.structuralForm.metric_id) = $event)),
                  class: "form-select",
                  disabled: !_ctx.structuralForm.metric_type_id
                }, [
                  _createElementVNode("option", _hoisted_91, _toDisplayString(_ctx.structuralForm.metric_type_id ? "Select metric" : "Select metric type first"), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics, (m) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: m.metric_id,
                      value: m.metric_id,
                      title: m.description
                    }, _toDisplayString(m.name) + " v" + _toDisplayString(m.version), 9, _hoisted_92))
                  }), 128))
                ], 8, _hoisted_90), [
                  [_vModelSelect, _ctx.structuralForm.metric_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _cache[68] || (_cache[68] = _createElementVNode("label", { class: "form-label" }, "Date first observed", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.structuralForm.date_first_observed) = $event)),
                  type: "date",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.structuralForm.date_first_observed]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _cache[69] || (_cache[69] = _createElementVNode("label", { class: "form-label" }, "Sensor axis: ", -1)),
                _createElementVNode("div", _hoisted_98, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['edge', 'flap', 'span'], (opt) => {
                    return _createElementVNode("button", {
                      key: opt,
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.structuralForm.axis.includes(opt) ? 'btn-primary' : 'btn-outline-primary']),
                      onClick: ($event: any) => (_ctx.toggleValue(_ctx.structuralForm.axis, opt))
                    }, _toDisplayString(opt), 11, _hoisted_99)
                  }), 64))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _cache[70] || (_cache[70] = _createElementVNode("label", { class: "form-label" }, "Sensor location: ", -1)),
                _createElementVNode("div", _hoisted_102, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['root', 'mid-span'], (opt) => {
                    return _createElementVNode("button", {
                      key: opt,
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.structuralForm.location.includes(opt) ? 'btn-primary' : 'btn-outline-primary']),
                      onClick: ($event: any) => (_ctx.toggleValue(_ctx.structuralForm.location, opt))
                    }, _toDisplayString(opt), 11, _hoisted_103)
                  }), 64))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _cache[71] || (_cache[71] = _createElementVNode("label", { class: "form-label" }, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.structuralForm.notes) = $event)),
                  class: "form-control",
                  rows: "3",
                  placeholder: "Describe the structural change observed..."
                }, null, 512), [
                  [_vModelText, _ctx.structuralForm.notes]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _cache[72] || (_cache[72] = _createElementVNode("label", { class: "form-label" }, "Attribute to damage", -1)),
                _createElementVNode("div", _hoisted_110, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.bladeHealthIdInput) = $event)),
                    type: "number",
                    class: "form-control",
                    placeholder: "Enter blade health ID that links this metric to damage",
                    onKeyup: _cache[33] || (_cache[33] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addBladeHealthId && _ctx.addBladeHealthId(...args)), ["enter"]))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.bladeHealthIdInput,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addBladeHealthId && _ctx.addBladeHealthId(...args)))
                  }, "Add")
                ]),
                (_ctx.structuralForm.blade_health_ids.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structuralForm.blade_health_ids, (id) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: id,
                          class: "badge bg-secondary d-inline-flex align-items-center gap-1"
                        }, [
                          _createTextVNode(_toDisplayString(id) + " ", 1),
                          _createElementVNode("span", {
                            role: "button",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.removeBladeHealthId(id))
                          }, "×", 8, _hoisted_112)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.structuralSaveError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(_ctx.structuralSaveError), 1))
            : _createCommentVNode("", true),
          (_ctx.structuralSaveSuccess)
            ? (_openBlock(), _createElementBlock("p", _hoisted_114, "Structural change saved successfully."))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.structuralSaving,
            onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.saveStructural && _ctx.saveStructural(...args)))
          }, _toDisplayString(_ctx.structuralSaving ? "Saving..." : "Save structural change"), 9, _hoisted_115)
        ]),
        _createElementVNode("div", _hoisted_116, [
          _cache[77] || (_cache[77] = _createElementVNode("h3", null, "Structural change records", -1)),
          (_ctx.bladeResponseLoading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_117, "Loading..."))
            : (!_ctx.structuralForm.site_id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_118, "Select a site to view structural change records."))
              : (_ctx.bladeResponseRecords.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_119, "No records found for the current selection."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.bladeResponseRecords.length) + " record" + _toDisplayString(_ctx.bladeResponseRecords.length === 1 ? "" : "s") + " found.", 1),
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("table", _hoisted_121, [
                        _cache[76] || (_cache[76] = _createElementVNode("thead", { class: "thead thead-dark" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Turbine / Blade"),
                            _createElementVNode("th", null, "Metric type"),
                            _createElementVNode("th", null, "Metric"),
                            _createElementVNode("th", null, "Axis"),
                            _createElementVNode("th", null, "Location"),
                            _createElementVNode("th", null, "Notes"),
                            _createElementVNode("th", null, "Health IDs")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladeResponseRecords, (r) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: r.blade_response_id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(r.date_first_observed.slice(0, 10)), 1),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(r.turbine_name) + " ", 1),
                                (r.blade_name)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" / " + _toDisplayString(r.blade_name) + " | " + _toDisplayString(r.blade_serial), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(r.metric_type_name), 1),
                              _createElementVNode("td", null, _toDisplayString(r.metric_name) + " v" + _toDisplayString(r.metric_version), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatTagField(r.metric_specific_tags, "axis")), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatTagField(r.metric_specific_tags, "location")), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatTagField(r.metric_specific_tags, "notes")), 1),
                              _createElementVNode("td", null, _toDisplayString(r.blade_health_ids && r.blade_health_ids.length ? r.blade_health_ids.join(", ") : "—"), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
        ])
      ])
    ])
  ]))
}